module.exports = __webpack_public_path__ + "static/media/vid2.16a23831.mp4";